import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { doc, setDoc, getDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../database/firebase";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
  updateProfile,
} from "firebase/auth";
import { useSelector, useDispatch } from "react-redux";
import { getDataDoc, updateDocDatabase } from "../../database";
import { testSlice } from "../../redux/store";
import { openErrorNotification } from "../../Components/Notifications/errorNotification";
import { initializeApp } from "firebase/app";
import {
  Button,
  Cascader,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Space,
  Divider,
  Switch,
} from "antd";
import { openSuccesNotification } from "../../Components/Notifications/succesNotification";

const { TextArea } = Input;
const { actions } = testSlice;
const { GET_TEACHER, ADD_MATERIE } = actions;
function AddProfesor({
  setOpen,
  open,
  confirmLoading,
  setConfirmLoading,
  materiiDefault = [],
  pregatiriDefault = [],
  liceuDefault = "",
  numeDeFamilieDefault = "",
  prenumeDefault = "",
  anDefault = "",
  ziDefault = "",
  typeFacturaDefault = "fizica",
  lunaDefault = "",
  localitateDefault = "",
  clasaDefault = "",

  numeFirmaDefault = "",
  cifFirmaDefault = "",
  numarRegComDefault = "",

  numeFacturaDefault = "",
  numarTelefonDefault = "",
  adresaEmailDafault = "",
}) {
  function generateSixDigitCode() {
    return Math.floor(100000 + Math.random() * 900000);
  }

  const [numeDeFamilie, setNumeDeFamilie] = useState(numeDeFamilieDefault);
  const [prenume, setPrenume] = useState(prenumeDefault);
  const dispatch = useDispatch();
  const [clasa, setClasa] = useState(clasaDefault);
  const [an, setAn] = useState(anDefault);
  const [numarTelefon, setNumarTelefon] = useState(numarTelefonDefault);
  const [adresaEmail, setAdresaEmail] = useState(adresaEmailDafault);

  const materii = useSelector((state) => state.materii);
  const [selectedMaterii, setSelectedMaterii] = useState([]);
  const profesori = useSelector((state) => state.profesori);

  const handleOk = async () => {
    setConfirmLoading(true);
    if (numeDeFamilie?.length === 0) {
      openErrorNotification("Numele de familie nu poate fi gol");
      return;
    }
    if (prenume?.length === 0) {
      openErrorNotification("Prenumele nu poate fi gol");
      return;
    }
    if (adresaEmail.length === 0) {
      openErrorNotification("Adresa Email nu este valida");
      return;
    }
    setConfirmLoading(true);
    try {
      const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
      };
      let Secondary = initializeApp(firebaseConfig, "secondary");
      let auth2 = getAuth(Secondary);
      let pass = generateSixDigitCode();

      createUserWithEmailAndPassword(auth2, adresaEmail, pass)
        .then(async (userCredentials) => {
          const user = userCredentials.user;
          await updateDocDatabase("mail", "mail" + pass + Date.now(), {
            to: [adresaEmail],
            message: {
              subject:
                numeDeFamilie +
                " " +
                prenume +
                " a fost înregistrat ca profesor în catalogul școlii",
              html: `
                <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
                  <div style="background-color: #ffffff; border-radius: 10px; padding: 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div style="text-align: center; margin-bottom: 30px;">
                      <h1 style="color: #2c3e50; margin-bottom: 10px;">📚 Bine ați venit!</h1>
                      <h2 style="color: #34495e; font-weight: normal; margin: 0;">Ați fost înregistrat ca profesor</h2>
                    </div>
                    
                    <div style="background-color: #e8f4f8; border-left: 4px solid #3498db; padding: 20px; margin: 20px 0; border-radius: 0 5px 5px 0;">
                      <h3 style="color: #2c3e50; margin-top: 0;">Bună ziua, ${numeDeFamilie} ${prenume}!</h3>
                      <p style="color: #34495e; line-height: 1.6; margin-bottom: 0;">
                        Ați fost adăugat cu succes ca profesor în catalogul școlii. Vă mulțumim că faceți parte din echipa noastră educațională!
                      </p>
                    </div>
                    
                    <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 20px; margin: 20px 0;">
                      <h3 style="color: #856404; margin-top: 0;">🔑 Datele dvs. de autentificare:</h3>
                      <table style="width: 100%; border-collapse: collapse;">
                        <tr>
                          <td style="padding: 8px 0; color: #495057; font-weight: bold;">Email:</td>
                          <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace;">${adresaEmail}</td>
                        </tr>
                        <tr>
                          <td style="padding: 8px 0; color: #495057; font-weight: bold;">Parolă temporară:</td>
                          <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace; font-weight: bold;">${pass}</td>
                        </tr>
                      </table>
                    </div>
                    
                    <div style="text-align: center; margin: 30px 0;">
                      <a href="${
                        process.env.REACT_APP_LINK
                      }?email=${encodeURIComponent(adresaEmail)}&pass=${pass}" 
                         style="display: inline-block; background-color: #3498db; color: white; padding: 12px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; box-shadow: 0 3px 6px rgba(52, 152, 219, 0.3);">
                        🚀 Accesează catalogul
                      </a>
                      <div style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 5px;">
                        <p style="color: #6c757d; font-size: 12px; margin: 5px 0;">Dacă butonul nu funcționează, copiați și lipiți acest link în browser:</p>
                        <p style="color: #495057; font-size: 12px; word-break: break-all; margin: 0;">
                          ${
                            process.env.REACT_APP_LINK
                          }?email=${encodeURIComponent(
                adresaEmail
              )}&pass=${pass}
                        </p>
                      </div>
                    </div>
                    
                    <div style="background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                      <p style="color: #721c24; margin: 0; text-align: center;">
                        <strong>⚠️ Important:</strong> Din motive de securitate, veți fi obligat să vă schimbați parola la prima autentificare.
                      </p>
                    </div>
                    
                    <div style="border-top: 1px solid #dee2e6; padding-top: 20px; margin-top: 30px; text-align: center;">
                      <p style="color: #6c757d; font-size: 14px; margin: 0;">
                        Dacă întâmpinați probleme la autentificare, vă rugăm să contactați administratorul.
                      </p>
                    </div>
                  </div>
                </div>
              `,
            },
          });
          let id = user.uid;
          await updateProfile(user, { emailVerified: true });
          signOut(auth2);
          updateDocDatabase("users", user.uid, {
            reset: true,
            required: true,
            otp: false,
            type: "profesor",
            uid: user.uid,
            adresaEmail,
            emailParinte: adresaEmail,
            prenume,
            displayName: numeDeFamilie + " " + prenume,
            numeDeFamilie,
          });

          await updateDocDatabase("profesori", id, {
            numeDeFamilie,
            prenume,

            id: id,
            adresaEmail,
            displayName: numeDeFamilie + " " + prenume,
            numarTelefon,

            selectedMaterii,
          });

          selectedMaterii.forEach(async (materie) => {
            let data = await getDataDoc("materii", materie);

            let profs = data?.profesori || [];

            await updateDocDatabase("materii", materie, {
              profesori: [...profs, id],
            });

            dispatch(
              ADD_MATERIE([
                ...materii.filter((mat) => mat.id !== materie),
                {
                  ...materii?.find((mat) => mat.id === materie),
                  profesori: [...profs, id],
                },
              ])
            );
          });
          dispatch(
            GET_TEACHER([
              {
                numeDeFamilie,
                prenume,

                adresaEmail,
                numarTelefon,

                selectedMaterii,
                id: id,
                text: prenume + " " + numeDeFamilie,
              },
              ...profesori,
            ])
          );
        })
        .catch((err) => openErrorNotification(err.message));
    } catch (e) {
      openErrorNotification(e.toString());
    }
    setConfirmLoading(false);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <Modal
      title="Adaugă Profesor"
      open={open}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
    >
      <Form
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 18,
        }}
        layout="horizontal"
        onValuesChange={() => {}}
      >
        <Form.Item label="Nume">
          <Input
            value={numeDeFamilie}
            onChange={(e) => {
              setNumeDeFamilie(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Prenume">
          <Input
            value={prenume}
            onChange={(e) => {
              setPrenume(e.target.value);
            }}
          />
        </Form.Item>

        <Form.Item label="Adresa email">
          <Input
            value={adresaEmail}
            onChange={(e) => {
              setAdresaEmail(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Telefon">
          <Input
            value={numarTelefon}
            onChange={(e) => {
              setNumarTelefon(e.target.value);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddProfesor;
